module.exports = __webpack_public_path__ + "images/emoji/smile_cat.77cc4a4b9ef8f143a5b8.png";